import Accordion from "../../components/Accordion";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Spinner from './../../assets/images/spinner.svg'
import { STRAPI_URL } from "../../config/env";

export default function Faq({ homepageData = {} }) {
  const [faqData, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const faqTitle = homepageData.FaqTitle ?? 'FAQ'

  function compare(a, b) {
    if (a.attributes.linkId < b.attributes.linkId) {
      return -1;
    }
    if (a.attributes.linkId > b.attributes.linkId) {
      return 1;
    }
    return 0;
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(`${STRAPI_URL}/api/faqs?populate=*`);
        setData(response.data.sort(compare));
      } catch (error) {
        console.error(error.message);
      }
      setLoading(false);
    }
    fetchData();
  }, [setData]);

  return (
    <div className="faq">
      <h1>{faqTitle}</h1>
      {loading && <div className='loading'><img src={Spinner} alt="loading animation" /></div>}
      {!loading && <Accordion
        questionsAnswers={faqData}
        defaultSelection={0}
      />}
    </div>
  );
}
